module.exports = __webpack_public_path__ + "img/SLP.f6b82033.svg";